<template>
    <zen-one 
    :showuserinfo="false" 
    title=""
    :crumbs="crumbs"
    >
        <z-page
            title="Senarai Jejak Audit"
            >
            <div class="w-card__content content-hardcode mb3">
                <w-form v-model="valid" @validate="cari" ref="frm">
                    <w-flex class="mt3">
                        <div class="xs4">
                        <w-input
                            v-model="pencarian.tarikh"
                            label="Tarikh"
                            type="date"
                            />
                        </div>
                        <div class="xs4">
                        <w-input 
                            v-model="pencarian.name"
                            label="Pengguna"
                            />
                        </div>
                        <div class="xs4">
                        <w-input
                            v-model="pencarian.remark"
                            label="Catatan"
                            />
                        </div>
                    </w-flex>
                    
                </w-form>

                <w-flex justify-end class="mt2">
                    <w-button
                    class="mr2"
                    v-on:click="resetPencarian()"
                    bg-color="warning"
                    ><w-icon>fal fa-redo</w-icon>&nbsp;RESET
                    </w-button>
                    <w-button
                    class="mr2"
                    bg-color="primary"
                    @click="$refs.frm.validate()"
                    ><w-icon>fal fa-search</w-icon>&nbsp;CARI
                    </w-button>
                </w-flex>
            </div>
            <z-table
                ref="tbluser"
                title="Jejak Audit"
                :headers="table.headers"  
                :items="table.items"
                :meta="table.meta"
                class=""
                >

                <template #header-label="{ header, label, index }">
                    <template v-if="header.key == 'action'">
                        Tindakan
                    </template>
                    <template v-else>
                        {{ label }}
                    </template>
                </template>

                <template #item-cell.action="{ item, label, header, index }">
                    <w-tooltip md top color="white" bg-color="black">
                        <template #activator="{ on }">
                            <w-button 
                                class="w-button w-button--dark size--md info-dark1--bg"
                                @click="papar(item)"
                                >
                                <w-icon md class="mr2">fal fa-eye</w-icon>
                            </w-button>
                        </template>
                        Papar
                    </w-tooltip>
                </template>
            </z-table>
            <w-dialog
                v-model="dialog.show"
                :fullscreen="dialog.fullscreen"
                :width="1300"
                :persistent="dialog.persistent"
                :persistent-no-animation="dialog.persistentNoAnimation"
                title-class="primary-dark1--bg white">
                <template #title>
                    <w-icon class="mr2">fal fa-cog</w-icon>
                    {{dialog.title}}
                </template>
                <br>
                <div class="w-table-wrap" style="max-height: 400px;">
                    <table class="w-table" color="light">
                    <thead>
                        <tr>
                            <th class="w-table__header text-center">Field</th>
                            <th class="w-table__header text-center">Before</th>
                            <th class="w-table__header text-center">After</th>
                        </tr>
                    </thead>

                    <tbody>
                        <tr v-for="item in compared" :key="item.field" 
                            :class="{ 'bg-yellow-100': item.changed }">
                            <td class="text-left">{{ item.field }}</td>
                            <td class="text-left">{{ item.before ?? '-'}}</td>
                            <td class="text-left">{{ item.after ?? '-'}}</td>
                        </tr>
                    </tbody>
                    </table>
                </div>
                <br>
                <template #actions>
                    <div class="spacer" />
                    <w-button style="
                        background-color: #f0f0f0; 
                        border: 2px solid red; 
                        color: #333; 
                        padding: 7px 14px; 
                        font-size: 11px; 
                        font-weight: bold; 
                        border-radius: 4px; 
                        cursor: pointer;
                    " @click="dialog.show = false">TUTUP</w-button>
                </template>
            </w-dialog>
        </z-page>
    </zen-one>
</template>

<script>
import { reactive } from 'vue'
import ZResource from '@/Modules/z-resource'

export default {
    extends: ZResource,
    props: {
        items: [Array, Object],
    },
    data() {
    return {
        dialog: {
            valid: false,
            show: false,
            fullscreen: false,
            persistent: true,
            persistentNoAnimation: false,
            loading: false,
            width: 1000,
        },
        resourceurl: 'penyelenggaraan.jejak-audit',
        crumbs: [
            { label: this.$page.props.app_name, route: '/' },
            { label: 'Penyelenggaraan', route: '/penyelenggaraan' },
            { label: 'Jejak Audit', route: '/penyelenggaraan/jejak-audit' }
        ],
      
        form: [],
        pencarian: {},
        auditJson: {
            data_sebelum: {},
            data_sesudah: {}
        },
        fieldsToShow: [
            { key: "lkp_jenis_pengguna", label: "Jenis Pengguna" },
            { key: "warga_negara", label: "Warga Negara" },
            { key: "name", label: "Nama" },
            { key: "no_id", label: "No Id" },
            { key: "email", label: "Email" },
            { key: "no_tel", label: "No. Telefon" },
            { key: "no_tel_pejabat", label: "No. Telefon Pejabat" },
            { key: "lkp_cawangan", label: "Tempat Bertugas" },
            { key: "alamat", label: "Alamat" },
            { key: "lkp_poskod", label: "Poskod" },
            { key: "lkp_bandar", label: "Bandar" },
            { key: "lkp_daerah", label: "Daerah" },
            { key: "lkp_negeri", label: "Negeri" },
            { key: "no_siri", label: "No. ID Jurusuntik" },
            { key: "tarikh_lantikan", label: "Tarikh Lantikan" },
            { key: "status", label: "Status" },
            { key: "role", label: "Peranan" }
        ]
    }
    },
    methods: {
        cari() {
            if(!this.valid) return;

            let params = {
                ...this.pencarian,
            };
            params.page = 1;
            params.per_page =9999;
            this.$inertia.visit(route(route().current(), params), {
                preserveState: true,
                preserveScroll: true,
            });
        },
        resetPencarian() {
            this.$inertia.visit(route(route().current()));
        },
        papar(data){
            this.auditJson= {
                    data_sebelum: {},
                    data_sesudah: {}
                };
            this.$zcomm.get(this.api_service + 'jejak-audit/show/'+data.id, {}).then(res => {
                this.form = res
                this.auditJson.data_sebelum = res.data_sebelum;
                this.auditJson.data_sesudah = res.data_sesudah;
            });

            this.dialog.show = true
            this.dialog.title = 'Papar'
        },
        submit(){
            aleert('sdf');
        },
        compareCustomFields(dataSebelum, dataSesudah, fields) {
            return fields.map(f => {
            const key = f.key;

            const before = dataSebelum?.[key];
            const after = dataSesudah?.[key];

            // Jika array, ubah ke string
            const beforeVal = Array.isArray(before) ? before.join(", ") : (before ?? "-");
            const afterVal = Array.isArray(after) ? after.join(", ") : (after ?? "-");

            return {
                field: f.label,
                key: key,
                before: beforeVal ?? "-",
                after: afterVal ?? "-",
                changed: beforeVal !== afterVal
            };
        });
    }
    },

    watch: {

    },
    computed: {
        compared() {
            return this.compareCustomFields(
                this.auditJson.data_sebelum,
                this.auditJson.data_sesudah,
                this.fieldsToShow
            );
        }
    },
    mounted() {
    // override default setting
    this.dialog.width = 500
  
      
    },
}
</script>
